module.exports = __webpack_public_path__ + "img/广发银行.ab7003ec.png";